import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_security",
  "use": "svg_security-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"svg_security\"><path d=\"M7.361 10.343 4.694 7.676l.713-.732L7.343 8.89l3.703-3.704.732.732-4.417 4.426ZM15.296.667v5.555c0 4.528-2.87 8.556-7.296 11.111C3.555 14.741.713 10.713.713 6.185V.63l14.583.037ZM14.25 1.704H1.75v4.481c0 3.824 2.268 7.408 6.25 9.926 3.981-2.51 6.25-6.102 6.25-9.926V1.704Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol